module.exports = __webpack_public_path__ + "static/media/time.8993624c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time.svg
// module id = 703
// module chunks = 0